import { SharedTable } from '@components';
import { useInventory } from '@hooks';
import { Inventory } from '@services';
import React from 'react';
import { InventoryFilters } from './components/InventoryFilters';
import { Columns, ExportColumns } from './InventoryTable.columns';

interface IProps {
  inventoryHook: ReturnType<typeof useInventory>;
  categoryOptions: { label: string; value: string }[];
  onEdit: (record: Inventory) => void;
  onDuplicate: (record: Inventory) => void;
  onReturnToSupplier: (record: Inventory) => void;
  onAddToPurchaseOrder: (record: Inventory) => void;
}

const InventoryTable: React.FC<IProps> = ({
  inventoryHook,
  categoryOptions,
  onEdit,
  onDuplicate,
  onReturnToSupplier,
  onAddToPurchaseOrder,
}) => {
  const {
    dateField,
    datePreset,
    customFrom,
    customTo,
    handleNameSearch,
    handleReferenceSearch,
    handlePartNumberSearch,
    handleNominalCodeSearch,
    handleInvoiceNumberSearch,
    handleCategoryFilter,
    handleSupplierFilter,
    handleDatePresetChange,
    handleCustomDateRange,
    handleDateFieldChange,
    handleHasDocumentFilter,
    handleLowStockFilter,
    handleIsInShopFilter,
  } = inventoryHook;

  return (
    <div style={{ width: '100%' }}>
      <InventoryFilters
        dateField={dateField}
        datePreset={datePreset}
        customFrom={customFrom}
        customTo={customTo}
        categoryOptions={categoryOptions}
        onDateFieldChange={handleDateFieldChange}
        onDatePresetChange={handleDatePresetChange}
        onCustomDateRange={handleCustomDateRange}
        onNameSearch={handleNameSearch}
        onReferenceSearch={handleReferenceSearch}
        onPartNumberSearch={handlePartNumberSearch}
        onNominalCodeSearch={handleNominalCodeSearch}
        onInvoiceNumberSearch={handleInvoiceNumberSearch}
        onCategoryFilter={handleCategoryFilter}
        onSupplierFilter={handleSupplierFilter}
        onHasDocumentFilter={handleHasDocumentFilter}
        onLowStockFilter={handleLowStockFilter}
        onIsInShopFilter={handleIsInShopFilter}
      />

      <SharedTable
        {...inventoryHook}
        exportable
        exportFileName="inventory"
        exportColumns={ExportColumns}
        onExportAll={inventoryHook.fetchAllForExport}
        columns={Columns({ onDuplicate, onReturnToSupplier, onAddToPurchaseOrder })}
        enableRowClick
        onRowClick={onEdit}
        mobileFilters={null}
        scrollX={undefined}
      />
    </div>
  );
};

export default InventoryTable;
